import { IJsonQuery } from './types/jsonQuery';

import { NonEmptyArray } from './types/common';
import { EFacilityType } from './types';
import { getTermValue } from './helpers';

export function getLivingConditions(jsonQuery: IJsonQuery): NonEmptyArray<EFacilityType> | null {
  const kidsAllowed = getTermValue('kids')(jsonQuery);
  const petsAllowed = getTermValue('pets')(jsonQuery);

  const livingConditions: EFacilityType[] = [];

  if (kidsAllowed) {
    livingConditions.push(EFacilityType.KidsAllowed);
  }

  if (petsAllowed) {
    livingConditions.push(EFacilityType.PetsAllowed);
  }

  return livingConditions.length > 0 ? (livingConditions as NonEmptyArray<EFacilityType>) : null;
}
